import React from 'react';
import styled from 'styled-components';
import Colors from '../../constants/Colors';
import data from "../../constants/data/ReklamLandingPageData.json";
import Image from "next/image";
import {useAmp} from "next/amp";

export const config = {amp: 'hybrid'}

declare global {
    namespace JSX {
        interface IntrinsicElements {
            [elemName: string]: any;
        }
    }
}

type IProps = {
    landingColumnData?: any
    imgAlt?: string
}

const LandingColumnComp = (props: IProps) => {

    const isAmp = useAmp();

    return (
        <React.Fragment>
            <LandingColumnCompContainer>
                <div className="wrapper">
                    {data.ColumnReklamLandingPageData.map((data: any) => (
                        <LandingColumnCompWrapper key={Math.random()}>
                            <div className={'landing-column-img'}>
                                {isAmp ? (
                                    <amp-img
                                        src={`${data.img}`}
                                        layout="fill"
                                        alt="Pembe Panjur"
                                    />
                                ) : (
                                    <React.Fragment>
                                        <Image
                                            src={`${data.img}`}
                                            layout={'fill'}
                                            alt={`Pembe Panjur, ` + props.imgAlt + `, ` + data.title}
                                            title={`Pembe Panjur, ` + props.imgAlt + `, ` + data.title}
                                            loading={data.lazy ? 'lazy' : 'eager'}
                                            priority={data.priority ? data.priority : false}
                                            sizes="(max-width: 768px) 100vw,
                                (max-width: 1200px) 50vw,
                                33vw"
                                            style={{
                                                objectFit: 'cover'
                                            }} />
                                    </React.Fragment>
                                )}

                            </div>
                            <div className={'landing-column-content'}>
                                <h2>
                                    {data.title}
                                </h2>
                                <LandingColumnCompContent dangerouslySetInnerHTML={{__html: data.content}}>
                                </LandingColumnCompContent>
                                <div className={'icon-img'}>
                                    {isAmp ? (
                                        <amp-img
                                            src={`${data.icon}`}
                                            width="145"
                                            height="145"
                                            layout="fixed"
                                            alt="Pembe Panjur"
                                        />
                                    ) : (
                                        <Image
                                            src={`${data.icon}`}
                                            alt={`Pembe Panjur, ` + props.imgAlt + `, ` + data.title}
                                            title={`Pembe Panjur, ` + props.imgAlt + `, ` + data.title}
                                            loading={'lazy'}
                                            width={1}
                                            height={1}
                                            style={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                objectFit: 'contain'
                                            }} />
                                    )}

                                </div>
                            </div>
                        </LandingColumnCompWrapper>
                    ))}
                </div>

            </LandingColumnCompContainer>

        </React.Fragment>
    );

}

export default LandingColumnComp;

const LandingColumnCompContainer = styled.div`
  position: relative;
  background-color: ${Colors.white};
  padding: 40px 24px 35px 24px;

  > .wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 0 calc(50vw - 575px);

    @media (max-width: 767px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

const LandingColumnCompWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${Colors.white};

  border-radius: 10px;
  box-shadow: 0px 40px 110px rgba(0, 0, 0, 0.05);

  .landing-column-img {
    position: relative;
    display: block;
    padding-top: 100%;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }

    > amp-img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .landing-column-content {
    width: 100%;
    height: 100%;
    padding: 36px 18px 34px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      font-weight: 800;
      font-size: 24px;
      line-height: 32px;
      text-align: center;
      letter-spacing: 0;
      text-transform: uppercase;
      color: ${Colors.black};
      margin: 0 0 26px;
    }

    > .icon-img {
      width: 100%;
      max-width: 145px;
      margin-top: 31px;
    }

  }
`;

const LandingColumnCompContent = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > p {
    margin: 0 0 20px 0;
    font-weight: 800;
    font-size: 20px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0;
    text-transform: lowercase;
    color: ${Colors.black};

    &:last-child {
      margin-bottom: 9px;
    }
  }
`;
